<ng-container *ngIf="{
    cat: taskCategory | async
  } as $">
<span *ngIf="$.cat;else empty">{{$.cat?.name_primary_language}}</span>
<ng-template #empty>-</ng-template>

</ng-container>
